import "./category-card.scss";

const CategoryCard = ({ imgSrc, cardText, onClick, isSelected}) => {
  return (
    <div className={`categoryCard ${isSelected? 'selected':'not-selected'}`} onClick={onClick}>
      <div className="category-text">{cardText}</div>
    </div>
  );
};

export default CategoryCard;
